<template>
  <el-container>
    <el-main>
      <pdf :page="currentPage" :src="url" ref="pdf"></pdf>
    </el-main>
    <el-footer>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="1"
        layout="prev, pager, next, jumper"
        :page-count="total"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
import pdf from "vue-pdf";
export default {
  components: { pdf },
  name: "Help",
  data() {
    return {
      url: "http://121.40.121.90:5010/dapi/u/downloadInstruction",
      total: 0,
      numPages: 0,
      currentPage: 1
    };
  },
  created() {
    this.pdfload();
  },
  watch: {
    currentPage(value) {}
  },
  methods: {
    pdfload() {
      this.url = pdf.createLoadingTask(this.url);
      this.url.promise.then(pdf => {
        this.total = pdf.numPages;
        this.numPages = pdf.numPages;
        // this.total = pdf.numPages = this.numPages;
      });
    },
    handleCurrentChange(value) {
      this.currentPage = value;
    }
  }
};
</script>
<style lang="less" scoped>
.el-container {
  height: 100%;
  .el-main {
    padding: 0;
  }
  .el-footer {
    text-align: center;
  }
}
</style>
